import { Routes } from '@angular/router';
import { FailedComponent } from "./failed/failed.component";
import { MsalGuard } from "@azure/msal-angular";

export const routes: Routes = [
  { path: '', redirectTo:'/archiverulesoverview', pathMatch:'full'},
  { path: 'archiverulesoverview', data: { title: 'Archive Rules Overview', showInNavbar: true }, canActivate: [MsalGuard],
    loadChildren: () => import('./archive-rules-overview/archive-rules.routes')
      .then(m => m.routes) },
  { path: 'merge', data: { title: 'Archive Rule Merge', showInNavbar: true }, canActivate: [MsalGuard],
    loadChildren: () => import('./archive-rules-overview/merge/merge.routes')
      .then(m => m.routes) },
  { path: 'connectors', data: { title: 'Connectors', showInNavbar: true }, canActivate: [MsalGuard],
    loadChildren: () => import('./connectors/connectors.routes')
      .then(m => m.routes) },
  { path: 'archiverulelabels', data: { title: 'Archive Rules Labels', showInNavbar: true }, canActivate: [MsalGuard],
    loadChildren: () => import('./archive-rules-overview/labels/labels.routes')
      .then(m => m.routes) },
  { path: 'auditarchiverules', data: { title: 'Archive Rules Audit', showInNavbar: true }, canActivate: [MsalGuard],
    loadChildren: () =>
      import('./archive-rules-overview/audit/audit-archive-rules-overview.routes')
      .then(m => m.routes) },
  { path: 'auditconnectors', data: { title: 'Connectors Audit', showInNavbar: true }, canActivate: [MsalGuard],
    loadChildren: () =>
      import('./connectors/audit/audit-connectors-overview.routes')
      .then(m => m.routes) },
  { path: 'auditarchiverulelabels', data: { title: 'Archive Rules Labels Audit', showInNavbar: true }, canActivate: [MsalGuard],
    loadChildren: () =>
      import('./archive-rules-overview/labels/audit/audit-archive-rules-label-overview.routes')
      .then(m => m.routes) },
  {
    path: 'login-failed',
    component: FailedComponent
  }
];
